import { GenericPageableResponse } from 'pageable'

import { axiosAuth } from '../../services/api/api'
import { User } from '../../types/users'

const requestUrl = 'users/'

export const getUser = (userKey: string) => {
    return axiosAuth.get<User>(`${requestUrl}${userKey}`)
}

export const getCurrentUser = () => axiosAuth.get<User>(`${requestUrl}/self`)

export const getAllUsers = () => {
    return axiosAuth.get<GenericPageableResponse<User[]>>(requestUrl)
}

export const createUser = (user: User) => {
    return axiosAuth.post(requestUrl, user)
}

export const deleteUser = (key: User['key']) => {
    return axiosAuth.delete(`${requestUrl}${key}`)
}

export const changeRoles = (roles: User['roles'], key: User['key']) => {
    return axiosAuth.patch<string>(`${requestUrl}${key}`, { roles })
}

export const changePassword = (password: string, key: User['key']) => {
    return axiosAuth.patch<string>(`${requestUrl}${key}`, { password })
}

export const changeEmail = (email: string, key: User['key']) => {
    return axiosAuth.patch<string>(`${requestUrl}${key}`, { email })
}

export const patchUserAcceptance = (
    consents: Pick<User, 'gdprAccepted' | 'termsAndConditionsAccepted'>
) => {
    return axiosAuth.patch<User>(`${requestUrl}acceptance`, consents)
}
